// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: oVA2o6W_9F
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import NavBar2 from "../../NavBar2"; // plasmic-import: lLCcoonTe6o/component
import HeroCityImg from "../../HeroCityImg"; // plasmic-import: 5TRnqrBQOr/component
import Form from "../../Form"; // plasmic-import: N4buk5LIp3R/component
import { Reveal } from "@plasmicpkgs/react-awesome-reveal";
import DotsImg from "../../DotsImg"; // plasmic-import: 7BvVw9X4KR/component
import GreenButton from "../../GreenButton"; // plasmic-import: OzMUV8kmkL/component
import ContactDiv from "../../ContactDiv"; // plasmic-import: K63AXAYlTq/component
import Footer from "../../Footer"; // plasmic-import: EvRh7yjThy6/component
import { useScreenVariants as useScreenVariantsrrBukHdQcoc } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: rrBukHDQcoc/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicHome.module.css"; // plasmic-import: oVA2o6W_9F/css
import ShopSvgrepoComSvgIcon from "./icons/PlasmicIcon__ShopSvgrepoComSvg"; // plasmic-import: uJ4ECvqjT3gj/icon
import Icon8Icon from "./icons/PlasmicIcon__Icon8"; // plasmic-import: ll0wG-CPCFX/icon
import RealEstateSvgrepoComSvgIcon from "./icons/PlasmicIcon__RealEstateSvgrepoComSvg"; // plasmic-import: _AnOib5hj755/icon
import TravelSvgrepoComSvgIcon from "./icons/PlasmicIcon__TravelSvgrepoComSvg"; // plasmic-import: 7wEK483RjOFM/icon
import anacostiapngCde19C97451F4Dc546FcPngNmEDxJl0JSOv from "./images/anacostiapngCde19C97451F4Dc546FcPng.png"; // plasmic-import: nmEDxJL0jSOv/picture
import _12F4Aa3AF2034DabB4B12A1Ece2106AePngFsRVvocZv82 from "./images/_12F4Aa3AF2034DabB4B12A1Ece2106AePng.png"; // plasmic-import: FsR-VvocZV82/picture
import _0B443E6CB68045F587516F06Cefe4C0BPngMl5XPzzeXSjp from "./images/_0B443E6CB68045F587516F06Cefe4C0BPng.png"; // plasmic-import: Ml5XPzzeXSjp/picture
import dmpedpngDb7969D714700986B261Png1DWbqZbDal1L from "./images/dmpedpngDb7969D714700986B261Png.png"; // plasmic-import: 1DWbqZbDal1L/picture
import pifpngC5E41054Efdbe7A1803CPngOpFz80POGN from "./images/pifpngC5E41054Efdbe7A1803CPng.png"; // plasmic-import: Op_Fz80pO-gN/picture
import dsoapng988E35Af57E75151583FPngLvsgm3F02Tdw from "./images/dsoapng988E35Af57E75151583FPng.png"; // plasmic-import: LVSGM3F02tdw/picture
import dcbiapng50Bd080Edab4Eae9Fa9FPngR7IWyIm3KZLg from "./images/dcbiapng50Bd080Edab4Eae9Fa9FPng.png"; // plasmic-import: r7iWYIm3kZLg/picture
import ogcpngCc1395215D6A15Baaf99PngJ7RWxDCzSgHi from "./images/ogcpngCc1395215D6A15Baaf99Png.png"; // plasmic-import: J7rWxDCzSGHi/picture
import sourceswpng6Ffde9A58B5E09Cb2215PngHkVde6PYsKsC from "./images/sourceswpng6Ffde9A58B5E09Cb2215Png.png"; // plasmic-import: hkVDE6pYSKsC/picture
import placeswpngC994Bde2D3D901480F85PngO1SnArdzLiy6 from "./images/placeswpngC994Bde2D3D901480F85Png.png"; // plasmic-import: O1SnArdzLIY6/picture
import terminalpng6Ba07D94B929064Ab165Png2PsxETslEBxX from "./images/terminalpng6Ba07D94B929064Ab165Png.png"; // plasmic-import: 2psxETslEBxX/picture
import framepngAd8A8Bcfce7B6636871APngC9UzHwjBvIvQ from "./images/framepngAd8A8Bcfce7B6636871APng.png"; // plasmic-import: C9UZHwjBVIvQ/picture
import _6Bf9Eb8FE8F640D0961D2Bbc45E96CfcPngROoEIbv4Hr9E from "./images/_6Bf9Eb8FE8F640D0961D2Bbc45E96CfcPng.png"; // plasmic-import: rOoEIbv4hr9e/picture
import _24791482Acf3477B9D221A98D517A8F5PngDusFwbgO1YtV from "./images/_24791482Acf3477B9D221A98D517A8F5Png.png"; // plasmic-import: DusFwbgO1ytV/picture
import _9B9492F3Ba6A41Cc98E20C138F26C2BcPngQxG3YGGvYWgG from "./images/_9B9492F3Ba6A41Cc98E20C138F26C2BcPng.png"; // plasmic-import: QxG3yGGvYWgG/picture
import _22915D34E25C47DeB2637A8653D4F6D9PngFbe6Jn4Qdo7F from "./images/_22915D34E25C47DeB2637A8653D4F6D9Png.png"; // plasmic-import: Fbe6Jn4qdo7f/picture
import _509561212F0B461AAd6831C83477F080PngIErCSQv6AG from "./images/_509561212F0B461AAd6831C83477F080Png.png"; // plasmic-import: iEr-cSQv6A-g/picture
import _825754E08F024B6BBbf8Fefa67C2933CPngLx0WbaOzwBkq from "./images/_825754E08F024B6BBbf8Fefa67C2933CPng.png"; // plasmic-import: LX0wbaOzwBkq/picture
import _7800D55B13B14F32A1A3F647E9A19A6DPngTx2KiOf1CmO9 from "./images/_7800D55B13B14F32A1A3F647E9A19A6DPng.png"; // plasmic-import: Tx2KiOf1CmO9/picture
import ba2Ae40602D14Ca7A87636583B4B181EPngJo6OnKKwtSpt from "./images/ba2Ae40602D14Ca7A87636583B4B181EPng.png"; // plasmic-import: JO6OnKKwtSPT/picture

createPlasmicElementProxy;

export const PlasmicHome__VariantProps = new Array();

export const PlasmicHome__ArgProps = new Array();

const $$ = {};

function PlasmicHome__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsrrBukHdQcoc()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <NavBar2
            data-plasmic-name={"navBar2"}
            data-plasmic-override={overrides.navBar2}
            className={classNames("__wab_instance", sty.navBar2)}
          />

          <div
            data-plasmic-name={"hero"}
            data-plasmic-override={overrides.hero}
            className={classNames(projectcss.all, sty.hero)}
          >
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.columns__pjHh)}
            >
              <div
                data-plasmic-name={"heroImgCol"}
                data-plasmic-override={overrides.heroImgCol}
                className={classNames(projectcss.all, sty.heroImgCol)}
              >
                <HeroCityImg
                  data-plasmic-name={"heroCityImg"}
                  data-plasmic-override={overrides.heroCityImg}
                  className={classNames("__wab_instance", sty.heroCityImg)}
                />
              </div>
              <div className={classNames(projectcss.all, sty.column__fCWs1)}>
                <Form
                  data-plasmic-name={"form"}
                  data-plasmic-override={overrides.form}
                  className={classNames("__wab_instance", sty.form)}
                />
              </div>
            </Stack__>
          </div>
          <div
            data-plasmic-name={"logos"}
            data-plasmic-override={overrides.logos}
            className={classNames(projectcss.all, sty.logos)}
          >
            <Reveal
              cascade={true}
              className={classNames("__wab_instance", sty.reveal__isHxm)}
              triggerOnce={true}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__lvAh1
                )}
              >
                {"Trusted By"}
              </div>
              <Stack__
                as={"div"}
                data-plasmic-name={"logosGroup"}
                data-plasmic-override={overrides.logosGroup}
                hasGap={true}
                className={classNames(projectcss.all, sty.logosGroup)}
              >
                <Stack__
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.columns__yOzdN)}
                >
                  <div
                    className={classNames(projectcss.all, sty.column__cMkNo)}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__dUjQ)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"eager"}
                      src={{
                        src: anacostiapngCde19C97451F4Dc546FcPngNmEDxJl0JSOv,
                        fullWidth: 305,
                        fullHeight: 172,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__hVCxi)}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__qZx)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"eager"}
                      src={{
                        src: _12F4Aa3AF2034DabB4B12A1Ece2106AePngFsRVvocZv82,
                        fullWidth: 346,
                        fullHeight: 115,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__oDJlW)}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__zTm0R)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"eager"}
                      src={{
                        src: _0B443E6CB68045F587516F06Cefe4C0BPngMl5XPzzeXSjp,
                        fullWidth: 487,
                        fullHeight: 165,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column___9IpI9)}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__t2T3A)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"eager"}
                      src={{
                        src: dmpedpngDb7969D714700986B261Png1DWbqZbDal1L,
                        fullWidth: 455,
                        fullHeight: 182,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__dc5AD)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__eHm0A)}
                    >
                      <PlasmicImg__
                        alt={""}
                        className={classNames(sty.img___6GAyz)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"none"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"eager"}
                        src={{
                          src: pifpngC5E41054Efdbe7A1803CPngOpFz80POGN,
                          fullWidth: 220,
                          fullHeight: 220,
                          aspectRatio: undefined
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__pxtgQ)}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__zOaDs)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"eager"}
                      src={{
                        src: dsoapng988E35Af57E75151583FPngLvsgm3F02Tdw,
                        fullWidth: 431,
                        fullHeight: 218,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__lm5DX)}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__yvbT3)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"eager"}
                      src={{
                        src: dcbiapng50Bd080Edab4Eae9Fa9FPngR7IWyIm3KZLg,
                        fullWidth: 199,
                        fullHeight: 236,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.column__xdnNg)}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__piGuG)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"eager"}
                      src={{
                        src: ogcpngCc1395215D6A15Baaf99PngJ7RWxDCzSgHi,
                        fullWidth: 353,
                        fullHeight: 168,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </Stack__>
              </Stack__>
            </Reveal>
          </div>
          <Stack__
            as={"div"}
            data-plasmic-name={"dots"}
            data-plasmic-override={overrides.dots}
            hasGap={true}
            className={classNames(projectcss.all, sty.dots)}
          >
            <div className={classNames(projectcss.all, sty.column__c3VuA)}>
              <DotsImg
                data-plasmic-name={"dotsImg"}
                data-plasmic-override={overrides.dotsImg}
                className={classNames("__wab_instance", sty.dotsImg)}
              />
            </div>
            <div className={classNames(projectcss.all, sty.column__bWm75)}>
              <Reveal
                cascade={true}
                className={classNames("__wab_instance", sty.reveal__o3ZM2)}
                triggerOnce={true}
              >
                <h2
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.h2__l2Ki
                  )}
                >
                  {"Innovative Consumer Intelligence"}
                </h2>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__m18Q9
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>
                      {
                        "Basil Labs leverages ethical, sustainable data practices to comprehensively track "
                      }
                    </React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ fontWeight: 700, color: "#6883FF" }}
                    >
                      {"consumer sentiment"}
                    </span>
                    <React.Fragment>{""}</React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#6883FF" }}
                    >
                      {" "}
                    </span>
                    <React.Fragment>{"and the "}</React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ fontWeight: 700, color: "#6883FF" }}
                    >
                      {"consumer journey"}
                    </span>
                    <React.Fragment>
                      {
                        " \u2014 store-by-store or across entire industries and nations.\n\nOur technology distills hundreds of millions of data points to "
                      }
                    </React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ fontWeight: 700, color: "#6883FF" }}
                    >
                      {"create richer, nuanced metrics"}
                    </span>
                    <React.Fragment>
                      {" that our clients can act on with confidence, thereby "}
                    </React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ fontWeight: 700, color: "#6883FF" }}
                    >
                      {"de-risking retail and real estate investments"}
                    </span>
                    <React.Fragment>
                      {
                        " and incorporating what consumers value most strongly in their "
                      }
                    </React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ fontWeight: 700, color: "#6883FF" }}
                    >
                      {"branding strategies and in-store experiences."}
                    </span>
                  </React.Fragment>
                </div>
              </Reveal>
            </div>
          </Stack__>
          <div
            data-plasmic-name={"data"}
            data-plasmic-override={overrides.data}
            className={classNames(projectcss.all, sty.data)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__x0Vfk
              )}
            >
              {"Our data"}
            </div>
            <Stack__
              as={"div"}
              data-plasmic-name={"sentimentMovement"}
              data-plasmic-override={overrides.sentimentMovement}
              hasGap={true}
              className={classNames(projectcss.all, sty.sentimentMovement)}
            >
              <div className={classNames(projectcss.all, sty.column___6Wkt9)}>
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__hhKYv)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"400px"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"100%"}
                  loading={"eager"}
                  src={{
                    src: sourceswpng6Ffde9A58B5E09Cb2215PngHkVde6PYsKsC,
                    fullWidth: 626,
                    fullHeight: 557,
                    aspectRatio: undefined
                  }}
                />
              </div>
              <div className={classNames(projectcss.all, sty.column__v4Wib)}>
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__r5E)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"400px"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"100%"}
                  loading={"eager"}
                  src={{
                    src: placeswpngC994Bde2D3D901480F85PngO1SnArdzLiy6,
                    fullWidth: 622,
                    fullHeight: 549,
                    aspectRatio: undefined
                  }}
                />
              </div>
            </Stack__>
          </div>
          <section
            data-plasmic-name={"sectors"}
            data-plasmic-override={overrides.sectors}
            className={classNames(projectcss.all, sty.sectors)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__oyWsx
              )}
            >
              {"Basil Tiles Build consumer mosaics"}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__kn0Sq
              )}
            >
              {"our sectors"}
            </div>
            <Stack__
              as={"div"}
              data-plasmic-name={"foreground"}
              data-plasmic-override={overrides.foreground}
              hasGap={true}
              className={classNames(projectcss.all, sty.foreground)}
            >
              <Stack__
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__idHfz)}
              >
                <Stack__
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__vfRAk)}
                >
                  <Stack__
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox___7Vsbj)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__qmZfV)}
                    >
                      <ShopSvgrepoComSvgIcon
                        className={classNames(projectcss.all, sty.svg__mmj5S)}
                        role={"img"}
                      />
                    </div>
                    {false ? (
                      <div
                        className={classNames(projectcss.all, sty.freeBox__eIS)}
                      >
                        <Icon8Icon
                          className={classNames(
                            projectcss.all,
                            sty.svg___4FzF4
                          )}
                          role={"img"}
                        />
                      </div>
                    ) : null}
                    <Stack__
                      as={"div"}
                      hasGap={true}
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___3Gyn1
                      )}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__huDbp
                        )}
                      >
                        {"Retail"}
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___4N4Lh
                        )}
                      >
                        {
                          "Nulla odio mauris enim parturient adipiscing vestibulum inceptos."
                        }
                      </div>
                    </Stack__>
                  </Stack__>
                  <Stack__
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__p21E)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__u2EMl)}
                    >
                      <RealEstateSvgrepoComSvgIcon
                        className={classNames(projectcss.all, sty.svg___61CQn)}
                        role={"img"}
                      />
                    </div>
                    <Stack__
                      as={"div"}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.freeBox___4IxU)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__nxgz8
                        )}
                      >
                        {"Real Estate"}
                      </div>
                    </Stack__>
                  </Stack__>
                  <Stack__
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__xrUYx)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__sy0D8)}
                    >
                      <TravelSvgrepoComSvgIcon
                        className={classNames(projectcss.all, sty.svg___46UX)}
                        role={"img"}
                      />
                    </div>
                    <Stack__
                      as={"div"}
                      hasGap={true}
                      className={classNames(projectcss.all, sty.freeBox__zyaWr)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__x02LI
                        )}
                      >
                        {"Tourism"}
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__cAFln
                        )}
                      >
                        {"Ut eu nam nostra taciti congue adipiscing curabitur."}
                      </div>
                    </Stack__>
                  </Stack__>
                </Stack__>
              </Stack__>
            </Stack__>
          </section>
          <div
            data-plasmic-name={"globalRankings"}
            data-plasmic-override={overrides.globalRankings}
            className={classNames(projectcss.all, sty.globalRankings)}
          >
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.columns__fH2F)}
            >
              <div className={classNames(projectcss.all, sty.column__eX36)}>
                <Reveal
                  cascade={true}
                  className={classNames("__wab_instance", sty.reveal__inYcb)}
                  triggerOnce={true}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__p6QzN
                    )}
                  >
                    {"Access Our Global Consumer Experience Index"}
                  </h2>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___5C5Dc
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>
                        {"Basil Labs' Global Consumer Experience Index "}
                      </React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ fontWeight: 700, color: "#6883FF" }}
                      >
                        {"benchmarks consumer sentiment"}
                      </span>
                      <React.Fragment>{" of some of the "}</React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ fontWeight: 700, color: "#6883FF" }}
                      >
                        {"largest brands"}
                      </span>
                      <React.Fragment>
                        {
                          " across the world.\n\nUsing millions of data points collected from social media and review platforms, the Index aggregates key sentiment metrics to identify trends and create a standardized metric for "
                        }
                      </React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ fontWeight: 700, color: "#6883FF" }}
                      >
                        {"competitive benchmarking."}
                      </span>
                    </React.Fragment>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___9Dx0T)}
                  >
                    <GreenButton
                      data-plasmic-name={"greenButton"}
                      data-plasmic-override={overrides.greenButton}
                      className={classNames("__wab_instance", sty.greenButton)}
                    />
                  </div>
                </Reveal>
              </div>
              <div className={classNames(projectcss.all, sty.column__joxvw)}>
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__lvwcL)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"eager"}
                  src={{
                    src: terminalpng6Ba07D94B929064Ab165Png2PsxETslEBxX,
                    fullWidth: 1310,
                    fullHeight: 1247,
                    aspectRatio: undefined
                  }}
                />
              </div>
            </Stack__>
          </div>
          <div
            data-plasmic-name={"tiles"}
            data-plasmic-override={overrides.tiles}
            className={classNames(projectcss.all, sty.tiles)}
          >
            <Stack__
              as={"div"}
              data-plasmic-name={"howItAllWorks"}
              data-plasmic-override={overrides.howItAllWorks}
              hasGap={true}
              className={classNames(projectcss.all, sty.howItAllWorks)}
            >
              <div className={classNames(projectcss.all, sty.column__k9KCt)}>
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__dImcT)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"eager"}
                  src={{
                    src: framepngAd8A8Bcfce7B6636871APngC9UzHwjBvIvQ,
                    fullWidth: 1200,
                    fullHeight: 831,
                    aspectRatio: undefined
                  }}
                />
              </div>
              <div className={classNames(projectcss.all, sty.column___50Znu)}>
                <Reveal
                  cascade={true}
                  className={classNames("__wab_instance", sty.reveal__li3LO)}
                  triggerOnce={true}
                >
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__dzTll
                    )}
                  >
                    {"Build a True Consumer Mosaic"}
                  </h2>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__d0BQu
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>
                        {
                          "Distill thousands of individual particles of data \u2014 "
                        }
                      </React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ fontWeight: 700, color: "#6883FF" }}
                      >
                        {"trends, sentiments, journeys, demographics"}
                      </span>
                      <React.Fragment>
                        {" \u2014 into ultra-precise Datasets. "}
                      </React.Fragment>
                    </React.Fragment>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__u9Lx6)}
                  >
                    <PlasmicLink__
                      data-plasmic-name={"greenButton2"}
                      data-plasmic-override={overrides.greenButton2}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        sty.greenButton2
                      )}
                      href={`/basil-tiles`}
                      platform={"react"}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__mdAus
                        )}
                      >
                        {"Learn more"}
                      </div>
                    </PlasmicLink__>
                  </div>
                </Reveal>
              </div>
            </Stack__>
          </div>
          <div
            data-plasmic-name={"featuredIn"}
            data-plasmic-override={overrides.featuredIn}
            className={classNames(projectcss.all, sty.featuredIn)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__uXF
              )}
            >
              {"Featured in"}
            </div>
            <Stack__
              as={"div"}
              data-plasmic-name={"logosGroup2"}
              data-plasmic-override={overrides.logosGroup2}
              hasGap={true}
              className={classNames(projectcss.all, sty.logosGroup2)}
            >
              <Stack__
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.columns__q5Ps5)}
              >
                <div className={classNames(projectcss.all, sty.column__jsZ1J)}>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___6VwFr)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"90px"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    src={{
                      src: _6Bf9Eb8FE8F640D0961D2Bbc45E96CfcPngROoEIbv4Hr9E,
                      fullWidth: 85,
                      fullHeight: 48,
                      aspectRatio: undefined
                    }}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__oGnv6)}>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__ezi6C)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"90px"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    src={{
                      src: _24791482Acf3477B9D221A98D517A8F5PngDusFwbgO1YtV,
                      fullWidth: 85,
                      fullHeight: 48,
                      aspectRatio: undefined
                    }}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__yz4O9)}>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__zocI)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"90px"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    src={{
                      src: _9B9492F3Ba6A41Cc98E20C138F26C2BcPngQxG3YGGvYWgG,
                      fullWidth: 85,
                      fullHeight: 48,
                      aspectRatio: undefined
                    }}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column___8Cucz)}>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__h8Xwj)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"90px"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    src={{
                      src: _22915D34E25C47DeB2637A8653D4F6D9PngFbe6Jn4Qdo7F,
                      fullWidth: 85,
                      fullHeight: 48,
                      aspectRatio: undefined
                    }}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column___3LRtH)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__ehWk1)}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__rSxm)}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"90px"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      src={{
                        src: _509561212F0B461AAd6831C83477F080PngIErCSQv6AG,
                        fullWidth: 85,
                        fullHeight: 48,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.column___5J6Xh)}>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__b9KQt)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"90px"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    src={{
                      src: _825754E08F024B6BBbf8Fefa67C2933CPngLx0WbaOzwBkq,
                      fullWidth: 85,
                      fullHeight: 48,
                      aspectRatio: undefined
                    }}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__ixPqL)}>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__chaPn)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"90px"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    src={{
                      src: _7800D55B13B14F32A1A3F647E9A19A6DPngTx2KiOf1CmO9,
                      fullWidth: 85,
                      fullHeight: 48,
                      aspectRatio: undefined
                    }}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.column__pkWIe)}>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__dkYYg)}
                    displayHeight={"auto"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"90px"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    src={{
                      src: ba2Ae40602D14Ca7A87636583B4B181EPngJo6OnKKwtSpt,
                      fullWidth: 85,
                      fullHeight: 48,
                      aspectRatio: undefined
                    }}
                  />
                </div>
              </Stack__>
            </Stack__>
          </div>
          <ContactDiv
            data-plasmic-name={"contactDiv"}
            data-plasmic-override={overrides.contactDiv}
            className={classNames("__wab_instance", sty.contactDiv)}
          />

          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "navBar2",
    "hero",
    "heroImgCol",
    "heroCityImg",
    "form",
    "logos",
    "logosGroup",
    "dots",
    "dotsImg",
    "data",
    "sentimentMovement",
    "sectors",
    "foreground",
    "globalRankings",
    "greenButton",
    "tiles",
    "howItAllWorks",
    "greenButton2",
    "featuredIn",
    "logosGroup2",
    "contactDiv",
    "footer"
  ],

  navBar2: ["navBar2"],
  hero: ["hero", "heroImgCol", "heroCityImg", "form"],
  heroImgCol: ["heroImgCol", "heroCityImg"],
  heroCityImg: ["heroCityImg"],
  form: ["form"],
  logos: ["logos", "logosGroup"],
  logosGroup: ["logosGroup"],
  dots: ["dots", "dotsImg"],
  dotsImg: ["dotsImg"],
  data: ["data", "sentimentMovement"],
  sentimentMovement: ["sentimentMovement"],
  sectors: ["sectors", "foreground"],
  foreground: ["foreground"],
  globalRankings: ["globalRankings", "greenButton"],
  greenButton: ["greenButton"],
  tiles: ["tiles", "howItAllWorks", "greenButton2"],
  howItAllWorks: ["howItAllWorks", "greenButton2"],
  greenButton2: ["greenButton2"],
  featuredIn: ["featuredIn", "logosGroup2"],
  logosGroup2: ["logosGroup2"],
  contactDiv: ["contactDiv"],
  footer: ["footer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHome__ArgProps,
          internalVariantPropNames: PlasmicHome__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHome__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHome";
  } else {
    func.displayName = `PlasmicHome.${nodeName}`;
  }
  return func;
}

export const PlasmicHome = Object.assign(
  // Top-level PlasmicHome renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navBar2: makeNodeComponent("navBar2"),
    hero: makeNodeComponent("hero"),
    heroImgCol: makeNodeComponent("heroImgCol"),
    heroCityImg: makeNodeComponent("heroCityImg"),
    form: makeNodeComponent("form"),
    logos: makeNodeComponent("logos"),
    logosGroup: makeNodeComponent("logosGroup"),
    dots: makeNodeComponent("dots"),
    dotsImg: makeNodeComponent("dotsImg"),
    data: makeNodeComponent("data"),
    sentimentMovement: makeNodeComponent("sentimentMovement"),
    sectors: makeNodeComponent("sectors"),
    foreground: makeNodeComponent("foreground"),
    globalRankings: makeNodeComponent("globalRankings"),
    greenButton: makeNodeComponent("greenButton"),
    tiles: makeNodeComponent("tiles"),
    howItAllWorks: makeNodeComponent("howItAllWorks"),
    greenButton2: makeNodeComponent("greenButton2"),
    featuredIn: makeNodeComponent("featuredIn"),
    logosGroup2: makeNodeComponent("logosGroup2"),
    contactDiv: makeNodeComponent("contactDiv"),
    footer: makeNodeComponent("footer"),
    // Metadata about props expected for PlasmicHome
    internalVariantProps: PlasmicHome__VariantProps,
    internalArgProps: PlasmicHome__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Basil Labs",
      description: "Where Your Consumers Go And What They Value",
      ogImageSrc:
        "https://site-assets.plasmic.app/33d1cf7aecefcec7ed7098f1ae83d3c8.png",
      canonical: ""
    }
  }
);

export default PlasmicHome;
/* prettier-ignore-end */
